import * as go from 'gojs';
import { getImagePanFeeder } from 'unitData/Feeders/Pan/getImagePanFeeder';
import { getImageBinding, getIOPort, makeNode } from '../../utils';

const PanFeederTemplate = makeNode(getImageBinding('', getImagePanFeeder), [
  getIOPort(go.Spot.Top, 'input'),
  getIOPort(go.Spot.Right, 'output'),
]);

export default PanFeederTemplate;
